import { getError } from '../../utils/requestUtils';
import {
  CLEAN_BROWSE_AI_WEBHOOK_LOGS,
  ERROR,
  GET_BROWSE_AI_WEBHOOK_LOG,
  LIST_BROWSE_AI_WEBHOOK_LOGS,
  START,
  SUCCESS
} from '../actions/types';

const INITIAL_STATE = {
  browseAiWebhookLogs: [],
  browseAiWebhookLog: null,
  pagination: null,

  listBrowseAiWebhookLogs: {},
  getBrowseAiWebhookLog: {}
};

export default function reducer(state = INITIAL_STATE, action) {
  const data = action.payload?.data;
  const error = getError(action.payload);

  switch (action.type) {
    case LIST_BROWSE_AI_WEBHOOK_LOGS + START:
      return { ...state, listBrowseAiWebhookLogs: { loading: true } };
    case LIST_BROWSE_AI_WEBHOOK_LOGS + SUCCESS:
      return {
        ...state,
        listBrowseAiWebhookLogs: { loading: false },
        browseAiWebhookLogs: data.result.items,
        pagination: data.result.pagination
      };
    case LIST_BROWSE_AI_WEBHOOK_LOGS + ERROR:
      return { ...state, listBrowseAiWebhookLogs: { loading: false, error } };

    case CLEAN_BROWSE_AI_WEBHOOK_LOGS + SUCCESS:
      return {
        ...state,
        listBrowseAiWebhookLogs: { loading: false },
        browseAiWebhookLogs: [],
        pagination: null,
        ...action.payload
      };

    case GET_BROWSE_AI_WEBHOOK_LOG + START:
      return { ...state, getBrowseAiWebhookLog: { loading: true } };
    case GET_BROWSE_AI_WEBHOOK_LOG + SUCCESS:
      return { ...state, getBrowseAiWebhookLog: { loading: false }, browseAiWebhookLog: data.item };
    case GET_BROWSE_AI_WEBHOOK_LOG + ERROR:
      return { ...state, getBrowseAiWebhookLog: { loading: false, error } };

    default:
      return { ...state };
  }
}
